export enum TranslationModeEnum {
  PLACEHOLDER = 1,
  TOOLTIP = 2,
  VIEWER = 3,
  INSERT_VALUE = 4,
  INSERT_VALUE_AND_REMOVE_TAGS = 5,
}
